<template>
  <div>
    <section
      class="mt-5 first-section d-flex flex-sm-column flex-md-column flex-lg-row justify-content-around"
    >
      <div class="indus_back_img wallet-card border-0 mb-3">
        <h5 class="mt-4 text-white">{{ $t("text.iWallet.walletBalance") }}</h5>
        <div
          class="d-flex mt-4 text-center mx-auto align-items-center card-middle"
        >
          <img
            src="../../../../../assets/img/wallet.png"
            alt="wallet"
            class="mr-3"
          />
          <h4 class="text-white text-center" v-if="!showLoader">
            <img
              src="../../../../../assets/img/naira.svg"
              alt="naira"
              width="23"
            />
            {{ companyCumulativeWallet }}
          </h4>
          <pulse-loader size="15px" v-if="showLoader"></pulse-loader>
        </div>
      </div>

      <div class="wallet-card bg-white mb-3">
        <div class="px-2">
          <h5 class="mt-4 text-left pl-3">
            {{ $t("text.iWallet.totalIncome") }}
          </h5>
          <div
            class="d-flex text-center mt-4 mx-auto align-items-center card-middle"
          >
            <img
              src="../../../../../assets/img/green-wallet.svg"
              alt="wallet"
              class="mr-3 wallet-img"
              width="55"
            />
            <h4 class="text-center" v-if="!showLoader">
              <img
                src="../../../../../assets/img/black-naira.svg"
                alt="naira"
                width="14"
              />
              {{ totalIncome }}
            </h4>
            <pulse-loader size="15px" v-if="showLoader"></pulse-loader>
          </div>
        </div>
      </div>

      <div class="wallet-card bg-white mb-3">
        <div class="px-2">
          <h5 class="mt-4 text-left pl-3">
            {{ $t("text.iWallet.totalExpenses") }}
          </h5>
          <div
            class="d-flex mt-4 text-center mx-auto align-items-center card-middle"
          >
            <img
              src="../../../../../assets/img/red-wallet.svg"
              alt="wallet"
              class="mr-3 wallet-img"
              width="55"
            />
            <h4 class="text-center" v-if="!showLoader">
              <img
                src="../../../../../assets/img/black-naira.svg"
                alt="naira"
                width="14"
              />
              {{ totalExpense }}
            </h4>
            <pulse-loader size="15px" v-if="showLoader"></pulse-loader>
          </div>
        </div>
      </div>
    </section>

    <!-- GRAPH SECTION -->
    <div
      class="showLoaderDiv charts__loader w-full mt-5 mx-auto"
      style="width: 90%; height: 100%"
      v-if="showLoader"
    >
      <div :class="showLoader ? 'loading' : null"></div>
    </div>
    <section class="graph-section bg-white mx-auto my-5" v-if="!showLoader">
      <highcharts :options="walletOption" class="py-5"></highcharts>
    </section>

    <!-- TABLE -->
    <!-- <section class="my-5 full__row_section table-section mx-auto">
      <ejs-grid
        v-show="!showLoader"
        ref="dataGrid"
        :created="refreshGrid"
        :allowPaging="true"
        :allowSorting="true"
        :pageSettings="pageSettings"
        :toolbar="toolbar"
        :searchSettings="search"
        :allowExcelExport="true"
        :allowPdfExport="true"
        :toolbarClick="toolbarClick"
        :locale="usedLang"
      >
        <e-columns>
          <e-column width="40" field="index" headerText="#"></e-column>
          <e-column field="tankName" width="180" headerText="Date"></e-column>
          <e-column
            field="volumeSold"
            width="180"
            headerText="Amount(Naira)"
          ></e-column>
          <e-column
            field="volumeFilled"
            width="180"
            headerText="Source"
          ></e-column>
          <e-column
            field="openingDip"
            width="180"
            headerText="Status"
          ></e-column>
          <e-column
            field="closingDip"
            width="180"
            headerText="Wallet Balance(Naira)"
          ></e-column>
        </e-columns>
      </ejs-grid>
      <TableLoader :showLoader="showLoader" />
    </section> -->
  </div>
</template>

<script>
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Dashboard:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    AdminMasterLayout,
    Highcharts: Chart,
    TableLoader,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    PulseLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  props: ["maxDate", "dateRange", "startDatee", "endDatee"],
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      startDate: this.startDatee,
      endDate: this.endDatee,
      companyID: this.$route.query.companyID,
      companyCumulativeWallet: 0,
      totalExpense: 0,
      totalIncome: 0,
      showLoader: true,
      walletOption: {
        chart: {
          type: "areaspline",
          animation: "true",
        },
        title: {
          text: "Transaction Chart",
        },
        xAxis: {
          categories: [],
          crosshair: true,
          areaspline: {
            fillOpacity: 0.1,
          },
        },
        yAxis: {
          title: {
            text: "Amount (Naira)",
          },
          areaspline: {
            fillOpacity: 0.1,
          },
        },
        colors: ["#FF4F79", "#90ee90"],
        plotOptions: {
          areaspline: {
            fillOpacity: 0.3,
          },
        },
        series: [],
      },
      showLoader: false,
      isDisabled: true,

      year: "2020",
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],

      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    this.getTotalWalletBalance();
    this.getWeekTransaction();
    this.getTransactionGraph();
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  watch: {
    tankDateRange: function (newDate) {
      if (newDate) {
        this.tankStartDate = this.$moment(newDate, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTanksProbeByHour();
      }
    },

    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTransactionGraph();
      }
    },

    companyID: function (newID, oldID) {
      localStorage.setItem("companyID", newID);
    },
  },
  mounted() {},
  computed: {
    walletStartDate() {
      return this.$moment(this.walletTransactionStartDate, "DD-MM-YYYY").format(
        "MMMM D, YYYY"
      );
    },
    walletEndDate() {
      return this.$moment(this.walletTransactionEndDate, "DD-MM-YYYY").format(
        "MMMM D, YYYY"
      );
    },
  },
  methods: {
    getTransactionGraph() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/WalletTransactionChart/${this.$route.query.companyID}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          console.log(res.data);
          let expenseSeries = [
            {
              name: "Expenses",
              data: res.data.expenses,
              color: "#FF4F79",
            },
          ];

          let incomeSeries = [
            {
              name: "Income",
              data: res.data.incomes,
              color: "#90ee90",
            },
          ];
          this.walletOption.series = [...expenseSeries, ...incomeSeries];
          let newDate = res.data.days.map((day) =>
            this.$moment(day).format("MMMM D")
          );
          this.walletOption.xAxis.categories = newDate;
        });
    },

    getTotalWalletBalance() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/TotalRemisWallet/${this.$route.query.companyID}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          this.companyCumulativeWallet = res.data.balance.toLocaleString(
            undefined,
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );
          this.$eventHub.$emit("company", response.data[0]);
        })
        .catch((error) => {});
    },

    // GET TOTAL BRANCH CONSUMPTION

    getWeekTransaction() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Last7DaysTransactions/${this.companyID}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.totalExpense = res.data.totalExpenses;
          this.totalIncome = res.data.totalIncome;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getCompanyWalletBalance(companyId) {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/IndustrialDashboard/BranchWalletBalance/${companyId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.companyCumulativeWallet = res.data.cumulativeBranchBalance;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    changeConsumptionStatus(e) {
      if (e.target.value === "hourly") {
        this.consumptionstatus = "hourly";
      } else if (e.target.value === "daily") {
        this.consumptionstatus = "daily";
      } else {
        this.consumptionstatus = "monthly";
      }
    },
    changeYear(e) {
      this.year = e.target.value;
      this.getMonthlyUsageChart();
    },

    getWalletBalance() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/branchwallet/${this.$route.query.branchId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.walletBalance = this.convertThousand(res.data.balance);
        })
        .catch((error) => {});
    },

    getPowerUseDailyUsage() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUseDaily/${this.$route.query.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.forEach((x) => {
            let date = new Date(x.date);
            const newDate = this.$moment(date).format("MMMM D");
            x.date = newDate;
          });
          let gen = res.data.filter((el) => el.source === "Generator");
          let powerGrid = res.data.filter((el) => el.source === "Power Grid");
          let genArr = [];
          let powerArr = [];
          let cats = [];

          gen.forEach((el) => {
            genArr.push(el.hours);
            cats.push(el.date);
          });
          let genSeries = [
            {
              name: "Generator",
              data: genArr,
              color: "#FCD462",
            },
          ];
          powerGrid.forEach((el) => {
            powerArr.push(el.hours);
          });
          let powerSeries = [
            {
              name: "Power Grid",
              data: powerArr,
              color: "#370F70",
            },
          ];

          this.dailyUsageChart.series = [...genSeries, ...powerSeries];
          this.dailyUsageChart.xAxis.categories = cats;
        })
        .catch((error) => {});
    },

    //COMPANY POWER USE
    getCompanyPowerUseDetails() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/IndustrialDashboard/PowerUse/${this.companyID}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let genArr = [];
          let pgArr = [];
          res.data.forEach((el, i) => {
            if (el.source === "Power Grid") {
              pgArr.push(el);
            } else if (el.source === "Generator") {
              genArr.push(el);
            }
          });
          const totalPgHours = pgArr.reduce((acc, cur) => {
            return acc + cur.hours;
          }, 0);
          const totalGenHours = genArr.reduce((acc, cur) => {
            return acc + cur.hours;
          }, 0);
          this.totalPgHours = totalPgHours
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.totalGenHours = totalGenHours
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
        .catch((error) => {});
    },

    getWalletTransactions() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/WalletTransactions/${this.$route.query.branchId}?startDate=${this.walletStartDate}&endDate=${this.walletEndDate}`,
          configObject.authConfig()
        )
        .then((res) => {})
        .catch((error) => {});
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
  .first-section {
    flex-flow: column wrap !important;
  }
}
.first-section {
  width: 92%;
  margin: auto auto;
}
.indus_back_img {
  background: url("../../../../../assets/img/Card balance.svg") no-repeat !important;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.wallet-card {
  height: 180px;
  border-radius: 20px;
  text-align: center;
  width: 350px;
  position: relative;
  box-shadow: 0px 3px 6px #0000000d;
  border-bottom: 4px solid #370f70;
}

.wallet-img {
  position: absolute;
  bottom: 13px;
  right: 0;
}

.wallet-card h5 {
  font-size: 14px;
}

.wallet-card .card-middle {
  width: 80%;
}
.wallet-card h4 {
  font-size: 35px;
}

.wallet-header {
  width: 90%;
  margin: auto auto;
}
.wallet-header {
  width: 90%;
  margin: auto auto;
}

.graph-section {
  width: 93%;
  border-radius: 30px;
}

.table-section {
  width: 95%;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}

.sub-nav a {
  color: #2b2b2b;
  font-size: 14px;
}

.active-nav {
  color: #370f70 !important;
  border-bottom: 2px solid #370f70;
}

.sub-nav {
  width: 98%;
  margin: auto auto;
  border-bottom: 1px solid rgba(98, 98, 98, 0.2);
}

.small_card {
  align-items: normal;
}
.small__card_content_wrapper {
  display: flex !important;
  justify-content: space-between;
  flex-direction: row;
  width: 93%;
  margin: auto auto;
  margin-top: 17px;
}
.dashboard__card__header {
  font-size: 12px;
  font-weight: 700;
}

.car_content_flex_wrapper {
  margin-top: 30px;
  width: 68px;
}
.small__card_content_wrapper span {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.01em;
  text-align: left;
}

@media only screen and (max-width: 600px) {
  .dashboard_chart {
    display: block;
  }
}

.table span {
  font-size: 12px;
  color: grey;
  font-weight: lighter;
}

.table-lga {
  line-height: 5px;
}
.table-lga p {
  font-size: 20px;
}
thead {
  border-bottom: 1px black solid;
}
.top_consumption button {
  padding: 10px 20px;
  border: 1px solid #494d6a;
  background-color: transparent;

  font-size: 14px;
  border-radius: 5px;
}
.table-link {
  position: absolute;
  bottom: 3%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media only screen and (min-width: 1200px) and (max-width: 1378px) {
  .wallet-card {
    width: 30%;
  }
  .wallet-card h4 {
    margin-top: 20px;
    font-size: 30px;
  }
}
</style>
